import { resolveImage } from "@/lib/api";

export default function Faculty({ data }) {
  const items = data?.items || [];
  return (
    <section id="faculty" data-testid="section-faculty" className="section-pad bg-white">
      <div className="container-pad">
        <div className="max-w-2xl">
          <div className="kicker">{data.kicker || "Meet the Mentors"}</div>
          <h2 className="heading-main mt-4">{data.title}</h2>
        </div>

        <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {items.slice(0, 3).map((f, i) => (
            <div
              key={i}
              className="group fade-up"
              style={{ animationDelay: `${i * 60}ms` }}
              data-testid={`faculty-card-${i}`}
            >
              <div className="aspect-[4/5] overflow-hidden rounded-2xl bg-slate-100">
                <img
                  src={resolveImage(f.image)}
                  alt={f.name}
                  className="w-full h-full object-cover group-hover:scale-105 transition duration-700"
                />
              </div>
              <div className="mt-4">
                <h3 className="text-base font-bold text-[#0F172A]">{f.name}</h3>
                <p className="text-sm text-teal-700 mt-0.5">{f.role}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
